import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { Cep } from 'src/app/admihair/api/dto/cep';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';
import { Municipio } from 'src/app/admihair/api/dto/municipio';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { CepService } from 'src/app/admihair/service/cep.service';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { IndicadorClienteService } from 'src/app/admihair/service/indicador-cliente.service';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ValidacaoUtil } from 'src/app/admihair/util/validacao-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-cliente-editar',
  templateUrl: './cliente-editar.component.html',
  styleUrls: ['./cliente-editar.component.scss']
})
export class ClienteEditarComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  idEmpresa?: number;
  temDuasPalavras: boolean = true;
  clienteCpfEncontrado: boolean = false;
  dataValida: boolean = true;
  progressoRequisicao: boolean = false;
  exibirSpinner: boolean = false;

  cliente?: Cliente;
  indicadoresClientes: string[] = [];
  contatoCliente: ContatoCliente = { principal: true };
  listaContatos: ContatoCliente[] = [];
  loadingContatos: boolean = false;
  modoEdicaoContatos: boolean = false;
  aniversarioCliente?: string;

  listaUfs: Uf[] = [];
  listaMunicipios: Municipio[] = [];

  ufSelecionado?: Uf;
  municipioSelecionado?: Municipio;

  isUfSelecionada: boolean = false;
  exibirMensagemCep: boolean = false;
  trocarCamposEndereco: boolean = false;
  exibirMensagemCepInvalido: boolean = false;
  cepEncontrado?: Cep;

  @ViewChild('f') form?: NgForm;

  constructor(private activatedRouter: ActivatedRoute,
    private clienteService: ClienteService,
    private confirmationService: ConfirmationService,
    private indicadorService: IndicadorClienteService,
    private contatoService: ContatoClienteService,
    private municipioService: MunicipioService,
    private ufService: UfService,
    private cepService: CepService,
    private utilStorageService: UtilStorageService,
    erroService: ErroService,
    storageService: UtilStorageService) {
      super(erroService, storageService)
     }

  ngOnInit(): void {
    this.exibirSpinner = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_CLIENTE');
    this.idEmpresa = this.utilStorageService.getEmpresa().id;
    this.carregarIdCliente();
    if (this.permissaoEditar) {
      this.carregarDadosCliente();
    }
  }

  carregarIdCliente() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarDadosCliente() {
    forkJoin([
      this.ufService.listarUf(),
      this.indicadorService.listarIndicadoresClientesPorEmpresa(this.idEmpresa),
      this.clienteService.buscarPorId(this.id),
      this.contatoService.listarPorClienteId(this.id)
    ]).subscribe({
      next: ([ufResponse, indicadoresReponse, clienteResponse, contatosResponse]) => {
        this.listaUfs = ufResponse;
        this.indicadoresClientes = indicadoresReponse.map((item) => item.descricao);
        this.cliente = clienteResponse;
        if (this.cliente.aniversario) {
          this.aniversarioCliente = this.converterAniversario(this.cliente.aniversario);
        }
        this.listaContatos = contatosResponse;
        this.exibirSpinner = false;
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  atualizarCliente() {
    this.progressoRequisicao = true;
    if (this.cliente) {
      this.cliente.aniversario = this.fomatarAniversario(this.aniversarioCliente?.toString());
      if (this.trocarCamposEndereco) {
        this.cliente.uf = this.ufSelecionado?.siglaUf;
        this.cliente.cidade = this.municipioSelecionado?.descricao;
      }
      this.clienteService.atualizar(this.cliente, this.id).subscribe({
        next: (data: Cliente) => {
          this.cliente = data;
          this.progressoRequisicao = false;
          this.exibirMensagemSucesso();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.exibirMensagemErro(err);
        }
      });
    }
  }

  consultarCep(cep: string) {
    if (cep && cep.length === 8) {
      this.cepService.buscarPorCodigo(cep).subscribe({
        next: (data: Cep) => {
          this.cepEncontrado = data;
          this.trocarCamposEndereco = false;
          this.preencherEndereco();
        },
        error: (err: any) => {
          if (err.status === HttpStatusCode.NotFound) {
            this.exibirMensagemCep = true;
            this.trocarCamposEndereco = true;
          } else {
            this.exibirMensagemErro(err);
          }
        }
      })
    } else {
      this.trocarCamposEndereco = false;
      this.exibirMensagemCepInvalido = true;
    }
  }

  preencherEndereco() {
    if (this.cepEncontrado && this.cliente) {
      this.cliente.logradouro = this.cepEncontrado.endereco;
      this.cliente.bairro = this.cepEncontrado.bairro;
      this.cliente.uf = this.cepEncontrado.estado;
      this.cliente.cidade = this.cepEncontrado.cidade;
    }
  }

  listarMunicipios() {
    if (this.ufSelecionado) {
      this.exibirMensagemCep = false;
      this.isUfSelecionada = true;
      this.municipioService.listarMuniciosPorUf(this.ufSelecionado.codigoUf).subscribe({
        next: (data: Municipio[]) => {
          this.listaMunicipios = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      }
      )
    }
  }

  salvarContato() {
    if (this.validarContatoCliente()) {
      this.loadingContatos = true;
      if(this.contatoCliente.id) {
        this.contatoService.atualizar(this.contatoCliente.id, this.contatoCliente).subscribe({
          next: (data: ContatoCliente) => {
            this.contatoCliente = { principal: false };
            this.modoEdicaoContatos = false;
            this.listarContatos();
          },
          error: (err: any) => {
            this.loadingContatos = false;
            this.exibirMensagemErro(err);
          }
        })
      } else {
        this.contatoCliente.cliente = this.cliente;
        this.contatoService.salvar(this.contatoCliente).subscribe({
          next: (data: ContatoCliente) => {
            this.contatoCliente = { principal: false };
            this.modoEdicaoContatos = false;
            this.listarContatos();
          },
          error: (err: any) => {
            this.loadingContatos = false;
            this.exibirMensagemErro(err);
          }
        })
      }
    }
    
  }

  listarContatos() {
    this.contatoService.listarPorClienteId(this.cliente?.id).subscribe({
      next: (data: ContatoCliente[]) => {
        this.listaContatos = data;
        this.loadingContatos = false
      },
      error: (err: any) => {
        this.loadingContatos = false
        this.exibirMensagemErro(err);
      }
    })
  }

  validarContatoCliente(): boolean {
    return this.contatoCliente.numero !== undefined &&
      this.contatoCliente.numero.length === 14;
  }

  excluirContato(contato: ContatoCliente) {
    if(contato.id) {
      this.confirmationService.confirm({
        message: 'Tem certeza que seja excluir?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.contatoService.excluir(contato.id).subscribe({
            next: () => {
              this.listarContatos();
              this.exibirMensagemSucesso();
            },
            error: (err: any) => {
              this.exibirMensagemErro(err)
            }
          })
          
        }
      });
    }

    
  }

  editarContato(contato: ContatoCliente) {
    this.modoEdicaoContatos = true;
    this.contatoCliente = contato;
    this.removerContato(contato);
  }

  removerContato(contato: ContatoCliente) {
    const posicao = this.listaContatos.indexOf(contato);
    this.listaContatos.splice(posicao, 1);
  }


  mostrarBotoes(): boolean {
    return Object.keys(this.contatoCliente).length > 1;
  }

  validarNome(event: any) {
    this.temDuasPalavras = ValidacaoUtil.validarMultiplasPalavras(event);
  }

  validarAniversario() {
    const aniversario = this.form?.value.aniversario;
    if (!aniversario) {
      return;
    }
    const [dia, mes] = aniversario.split('/').map(Number);
    if (isNaN(dia) || isNaN(mes)) {
      return;
    }
    const diasPorMes = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    this.dataValida = (mes >= 1 && mes <= 12) &&
      (dia >= 1 && dia <= diasPorMes[mes]);
  }

  fomatarAniversario(aniversario?: string): Date | undefined {
    if (aniversario !== '' && aniversario !== undefined) {
      const [day, month] = aniversario?.split('/');
      const dataFormatada = new Date(new Date().getFullYear(), Number(month) - 1, Number(day));
      return new Date(dataFormatada);
    }
    return undefined;
  }

  converterAniversario(aniversario: Date): string {
    const data = aniversario?.toString();
    const [ano, mes, dia] = data.split('-').map(String);
    return dia + '' + mes;
  }

  camposPreenchendo() {
    this.exibirMensagemCep = false;
  }

}
